// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import swal from 'sweetalert'
import vant from 'vant'
import 'vant/lib/index.css'
import axios from './http'
import ElementUI, {
	Message
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题



Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(vant)

//fastclick.attach(document.body)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js